import React from "react";
import { Grid, Button } from "semantic-ui-react";
import PropTypes from "prop-types";

const PagarPrestamosFooter = ({ disabled, submitting }) => {
  return (
    <Grid columns={3}>
      <Grid.Column computer={6} largeScreen={6} mobile={3} tablet={4} />
      <Grid.Column computer={4} largeScreen={4} mobile={10} tablet={8}>
        <Button
          disabled={submitting || disabled}
          fluid
          size="large"
          loading={submitting}
          color="yellow"
          content="Siguiente"
        />
      </Grid.Column>
      <Grid.Column computer={6} largeScreen={6} mobile={3} tablet={4} />
    </Grid>
  );
};

PagarPrestamosFooter.propTypes = {
  disabled: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
};

export default PagarPrestamosFooter;
